<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Informe Nómina de Pagos</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div style='text-align:justific' slot="header">

            <strong class="izquierda">Filtros del Informe</strong>
            <strong class="derecha">GARANTÍA</strong>

          </div>
          
          <b-row>
            <b-col sm="3">
              <b-form-group 
              
                :label="crearLabel('Informes de liquidación recibidos hasta', 'fecha', 'datosFormulario')"
                label-for="fecha"
                :horizontal="false"
              >
                <b-input-group size="sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker 
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormulario.fhasta"
                    :disabled="campoBloqueado('fhasta', 'datosFormulario')"
                  ></datepicker>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.fecha }}</span>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                :label="crearLabel('Nomina', 'codnomina', 'datosFormulario')"
                label-for="codnomina"
                size="sm"
              >
                <b-form-select
                  :options="valNomina"
                  v-model="datosFormulario.codnomina"
                  :disabled="campoBloqueado('codnomina', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codnomina }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                :label="crearLabel('Producto', 'codproducto', 'datosFormulario')"
                label-for="codproducto"
              >
                <b-form-select
                  :options="valProducto"
                  v-model="datosFormulario.codproducto"
                  :disabled="campoBloqueado('codproducto', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codproducto }}</span>
              </b-form-group>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                  <b-button variant="success" @click="modalGuardar = true" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Asignar Fecha
                  </b-button>
                  <b-button variant="warning" @click="modificar" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-edit"></i> Modificar Fecha
                  </b-button>
                  <b-button variant="danger" @click="modalQuitar = true" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-edit"></i> Quitar Fecha
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Informe Nómina de Pagos</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input size="sm"
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="DocContishare(scope.row.Siniestro, scope.row)">Ver</el-button>   
                  </template>
                </el-table-column>

                <el-table-column type="selection" width="35" reserve-selection><!-- reserve-selection -->
                </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      title="Fecha Nómina de Pagos"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalGuardar"
      @ok="guardarprocede();"
      @cancel="modalGuardar = false"
    >
      <b-input-group>
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <datepicker
            :language="es"
            format="dd/MM/yyyy"
            :use-utc="true"
            input-class="form-control"
            v-model="datosFormulario.hoy"
            :disabled="campoBloqueado('hoy', 'datosFormulario')"
          ></datepicker>
          <span class="error-validacion-campo">{{ mensajeValidacionCampo.hoy }}</span>
        </b-input-group>
        <br>
        Los nuevos registros marcado se guardaran con la fecha de pago seleccionada, los registros que ya tenian una fecha de pago asignada no se cambiara su fecha.  
      </b-modal>

    <b-modal
      title="Modificación Fecha Nómina de Pagos"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalModificar"
      @ok="modificarprocede();"
      @cancel="modalModificar = false"
    >
      <b-input-group>
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <datepicker
            :language="es"
            format="dd/MM/yyyy"
            :use-utc="true"
            input-class="form-control"
            v-model="datosFormulario.hoy"
            :disabled="campoBloqueado('hoy', 'datosFormulario')"
          ></datepicker>
          <span class="error-validacion-campo">{{ mensajeValidacionCampo.hoy }}</span>
        </b-input-group>
        <br>
        Se modificara la "Fecha Pago Nómina" de los registros marcados con la fecha de pago seleccionada.  
      </b-modal>

    <b-modal
      title="Quitar Fecha Nómina de Pagos"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalQuitar"
      @ok="quitarFecha();"
      @cancel="modalQuitar = false"
    >
        Se quitara la "Fecha Pago Nómina" de los registros marcados.  
    </b-modal>

    <!-- Detalle Documentación de Contishare -->
    <b-modal
      hide-footer
      size="lg"
      title="Documentación de Contishare"
      cancel-title="Cerrar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalDocContishare"
      @ok="guardarLinkContishare();"
      @cancel="modalDocContishare = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataDocContishare"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @select="handleSelectionChange2"
                  @select-all="selectAll"                  
                >
                  <el-table-column
                    v-for="title in titlesDocContishare"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  
                  <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="verDocumento(scope.row.LINK)">Ver</el-button>   
                  </template>
                  </el-table-column>

                  <!-- <el-table-column type="selection" width="35" reserve-selection>
                  </el-table-column>


                  <el-table-column label="" min-width="10px" align="center">
                  </el-table-column> -->

                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarNomina from "@/components/services/apiGarNomina";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "InformeNóminadePagos",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      exportar: false,
      tieneAcceso: true,
      modalGuardar: false,
      modalModificar: false,
      modalQuitar: false,
      modalDocContishare: false,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      dataDocContishare: [],
      nombreexcel: "InformeNóminadePagos",
      titles: [
        {
          prop: "Producto",
          label: "Producto",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "Póliza",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "Siniestro",
          label: "Siniestro",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "Afianzado",
          label: "Afianzado",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "Beneficiario",
          label: "Beneficiario",
          align: "left",
          minwidth: "350",
        },
        {
          prop: "Ejec Sin.",
          label: "Ejec Sin.",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "Fecha Est. Config",
          label: "Fecha Est. Config",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "Fecha Recep. Inf. Liq.",
          label: "Fecha Recep. Inf. Liq.",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "Moneda",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "Provisión beneficiario",
          label: "Provisión beneficiario",
          align: "right",
          minwidth: "120",
        },
        {
          prop: "Nómina",
          label: "Nómina",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "Fecha Pago Nómina",
          label: "Fecha Pago Nómina",
          align: "center",
          minwidth: "120",
        },
      ],

      titlesDocContishare: [
        {
          prop: "CSHTITULO",
          label: "Categoría - Nombre del Documento",
          align: "left",
          minwidth: "250",
        },      
        {
          prop: "FECHA",
          label: "Fecha",
          align: "center",
          minwidth: "120",
        },    
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else if (prop === 'Fecha Recep. Inf. Liq.'){
                let elDate = new Date(row["Fecha Recep. Inf. Liq."])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else if (prop === 'Fecha Pago Nómina'){
                let elDate = new Date(row["Fecha Pago Nómina"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              } else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valNomina: [],
      valProducto: [],

      multipleSelection: [],
      multipleSelectionDelete: [],
      multipleSelectionModificar: [],
      multipleSelectionFiltrado: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "Siniestro"
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {
    customButtonsForRow(row) {
     
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "Informe Liquidación";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }
          
          return botones;

    },

    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleSelectionChange2(selection, row) {

      this.nomdoccontish = row.CSHTITULO;
      this.linkdoccontish = row.LINK;

      // this.link = row
      // debugger;
      if (selection.length > 1 ) {
            this.crearNotificacion("Error de sistema", "Solo se puede seleccionar un solo registro", "error");
            this.$refs.refTable3.$children[0].toggleRowSelection(row, false);
            return;
           }
    },

    selectAll(rows){
      this.$refs.refTable3.$children[0].clearSelection();
      return;
    },

    DocContishare(siniestro, row){
      this.$Progress.start();
      return apiGarNomina
        .DocContishare(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataDocContishare = response.data.res1;
          this.datalink = row;
          this.modalDocContishare = true;
          
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    verDocumento(link) {
      window.open(link, '_blank');
    },

    guardarLinkContishare(){

      apiGarNomina
          .guardar_link_contishare(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datalink.Siniestro,
            this.linkdoccontish,
            this.nomdoccontish
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Link Contishare",
                "Link de Contishare guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      console.log(n);
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    pre_insertar() {
      
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      //this.multipleSelection = [];
      this.value = null;

      return apiGarNomina
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.fhasta = lista_data[i]["fhasta"];
            this.datosFormulario.hoy = lista_data[i]["hoy"];
            this.datosFormulario.codnomina = lista_data[i]["codnomina"];
            this.datosFormulario.codproducto = lista_data[i]["codproducto"];
          }
          
          //Carga lista de nominas
          var tiposNominas = new Array();
          var lista_tipos_nominas = response.data.nomina;
          for(var i = 0; i < lista_tipos_nominas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_nominas[i]["codnomina"];
              obj.text = lista_tipos_nominas[i]["desnomina"];
              tiposNominas.push(obj);
          }
          this.valNomina = tiposNominas;

          //Carga lista de nominas
          var tiposProductos = new Array();
          var lista_tipos_productos = response.data.producto;
          for(var i = 0; i < lista_tipos_productos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_productos[i]["codproducto"];
              obj.text = lista_tipos_productos[i]["desproducto"];
              tiposProductos.push(obj);
          }
          this.valProducto = tiposProductos;

          //limpiar checks
          //this.multipleSelection = [];

          this.datosFormularioEstado = response.data.festado;

          this.buscar();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      //this.multipleSelection = [];
      //this.data = [];
      return apiGarNomina
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fhasta,
          this.datosFormulario.codnomina,
          this.datosFormulario.codproducto
        )
        .then((response) => {
          
          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha Est. Config" || column.property == "Fecha Recep. Inf. Liq." || 
           column.property == "Fecha Pago Nómina") 
          && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Informe Nómina de Pagos</td>\n";
      cuerpo += "</tr>\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Informes de liquidación recibidos hasta: " +
        this.datosFormulario.fhasta +
        "</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["Producto"] == undefined){
          this.data[key]["Producto"] = "";
        }
        if(this.data[key]["Póliza"] == undefined){
          this.data[key]["Póliza"] = "";
        }
        if(this.data[key]["Siniestro"] == undefined){
          this.data[key]["Siniestro"] = "";
        }
        if(this.data[key]["Afianzado"] == undefined){
          this.data[key]["Afianzado"] = "";
        }
        if(this.data[key]["Beneficiario"] == undefined){
          this.data[key]["Beneficiario"] = "";
        }
        if(this.data[key]["Ejec Sin."] == undefined){
          this.data[key]["Ejec Sin."] = "";
        }
        if(this.data[key]["Fecha Est. Config"] == undefined){
          this.data[key]["Fecha Est. Config"] = "";
        }
        if(this.data[key]["Fecha Recep. Inf. Liq."] == undefined){
          this.data[key]["Fecha Recep. Inf. Liq."] = "";
        }
        if(this.data[key]["Moneda"] == undefined){
          this.data[key]["Moneda"] = "";
        }
        if(this.data[key]["Provisión beneficiario"] == undefined){
          this.data[key]["Provisión beneficiario"] = "";
        }
        if(this.data[key]["Nómina"] == undefined){
          this.data[key]["Nómina"] = "";
        }
        if(this.data[key]["Fecha Pago Nómina"] == undefined){
          this.data[key]["Fecha Pago Nómina"] = "";
        }

        var chk;
        if(this.data[key]["chk"] == "0"){
          chk = ""; //this.data[key]["Marcado para Pago"] = "NO";
        }else{
          chk = "Chequeado"; //this.data[key]["Marcado para Pago"] = "SI";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Póliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Siniestro"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Afianzado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Beneficiario"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Ejec Sin."] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Est. Config"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Recep. Inf. Liq."])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Moneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["Provisión beneficiario"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["Nómina"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Pago Nómina"])+"</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    guardar(){
      // if (this.validarDesmarcados()){
      //   this.eliminarprocede();
      // }
      
      var ret = false;
      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (this.multipleSelection[index]["Fecha Pago Nómina"] == undefined){
            ret = true;
          }
      }

      if (ret){
        this.modalGuardar = true;
      }
    },

    modificar(){
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.Siniestro);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["Siniestro"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      this.multipleSelectionModificar = marcados;
      if (this.multipleSelectionModificar.length > 0){
        this.modalModificar = true;
      }else{
        this.crearNotificacion(
                "Marcar para Pago",
                "No tiene siniestros seleccionados para cambiar la Fecha Nómina Pago.",
                "error"
              );
      }
      
    },

    guardarprocede(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.Siniestro);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["Siniestro"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      this.multipleSelectionFiltrado = marcados;
      /* -- */
      



      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
          if (marcados[index]["Fecha Pago Nómina"] == undefined){
            if (marcados[index]["Nómina"] != 'Sin Nómina') {
              siniestrosMarcados += marcados[index]["Siniestro"] + ',';
            }
          }
      }

      

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarNomina
          .marcarparapago(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.hoy,
            siniestrosMarcados
          )
          .then(response => {

            this.$Progress.finish();
            this.crearNotificacion(
                "Marcar para Pago",
                "Se han guardado con los registros marcados para pago.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    modificarprocede(){
      this.$Progress.start();
      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < this.multipleSelectionModificar.length; ++index) {
        if (this.multipleSelectionModificar[index]["Nómina"] != 'Sin Nómina') {
          siniestrosMarcados += this.multipleSelectionModificar[index]["Siniestro"] + ',';
        } 
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarNomina
          .modificarfecha(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.hoy,
            siniestrosMarcados
          )
          .then(response => {
            
            this.crearNotificacion(
                "Marcar para Pago",
                "Se modificó la fecha para los siniestros seleccionados.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    eliminarprocede(){
      var siniestrosDesmarcados = "";
      var index = 0;
      for (index = 0; index < this.multipleSelectionDelete.length; ++index) {
          siniestrosDesmarcados += this.multipleSelectionDelete[index]["Siniestro"] + ',';
      }

      if (siniestrosDesmarcados != ""){
        siniestrosDesmarcados = siniestrosDesmarcados.slice(0, -1)
        apiGarNomina
          .desmarcarparapago(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosDesmarcados
          )
          .then(response => {
            this.multipleSelectionDelete = [];
            this.crearNotificacion(
                "Desmarcar para Pago",
                "Se han eliminado los registros desmarcados para pago.",
                "success"
              );

            var ret = false;
            for (var index = 0; index < this.multipleSelection.length; ++index) {
                if (this.multipleSelection[index]["Fecha Pago Nómina"] == undefined){
                  ret = true;
                }
            }
            if (!ret){
              this.buscar();
            }

          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    validarDesmarcados(){
      var ret = false;
      this.multipleSelectionDelete = [];
      for (var index = 0; index < this.data.length; ++index) {
          if (this.data[index]["chk"] == "1"){
            if (!this.multipleSelection.includes( this.data[index])){
              this.multipleSelectionDelete.push(this.data[index]);
              ret = true;
            }
          }
      }
      return ret;
    },

    quitarFecha(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.Siniestro);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["Siniestro"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      this.multipleSelectionFiltrado = marcados;
      /* -- */
      



      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
          if (marcados[index]["Fecha Pago Nómina"] != undefined){
            siniestrosMarcados += marcados[index]["Siniestro"] + ',';
          }
      }

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarNomina
          .quitarfecha(
            this.$session.get("mail"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Quitar fecha de Pago",
                "Se han quitado las fecha de pago par los registros marcados.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    // prueba(){
    //   console.log(this.$refs.refTable1.tableData)
    // }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        // for (index = 0; index < lista.length; ++index) {
        //     if (lista[index]["chk"] == "1"){
        //       this.toggleSelection([lista[index]]);
        //     }
        // }
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.derecha   { float: right; color: #20a8d8;}
.izquierda { float: left;  }

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
</style>
